import { EMPTY_VALUE } from '../../utils/common'

const LIMIT = 5 // years

// Only get 5 years and add N/A on between min and max year. Example: if response is '2020, 2018, 2010', formatted is 2020, N/A, 2018.
export const getListYears = (availableData) => {
  const result = []

  if (!availableData) {
    return []
  }

  const listYears = availableData
    .split(',')
    .map((item) => item?.toString()?.trim())
    .filter((item) => item !== EMPTY_VALUE && item !== '')
    .sort()

  if (listYears.length === 1) {
    return listYears
  }

  const maxYear = +listYears[listYears.length - 1]
  let minYear = maxYear

  listYears.forEach((year) => {
    if (+year < minYear && +year > maxYear - LIMIT) {
      minYear = +year
    }
  })

  for (let index = minYear; index <= maxYear; index++) {
    if (listYears.includes(index?.toString())) {
      result.push(index?.toString())
    } else {
      result.push(EMPTY_VALUE)
    }
  }

  return result
}
